<template lang="pug">
    section.article-prices-tab
        Price.main-price(
            v-if="mainPriceIndex >= 0"
            :form="form"
            :rules="rules"
            :price="form.prices[mainPriceIndex]"
            module="article"
            deletable
        )
        a.price-placeholder(v-else-if="productMainPriceIndex >= 0" href="#" @click="addMainPrice")
            .overlay
                .info {{ $t('Define an individual article price') }}
            Price(
                :form="product.form"
                :price="product.form.prices[productMainPriceIndex]"
            )
        transition(name="slide-decent-vertical")
            .special-prices(v-if="specialPrices.length")
                transition-group(name="slide-decent-vertical" tag="div")
                    Price(
                        v-for="(price, i) in form.prices" :key="price.id"
                        v-if="price.type !== 'main'"
                        :form="form"
                        :rules="rules"
                        :price="price"
                        module="article"
                    )
        //- el-button(
        //-     v-if="mainPriceIndex < 0"
        //-     type="success"
        //-     icon="el-icon-fa-plus fas"
        //-     @click="addMainPrice"
        //- ) {{ $t('Add a different main price') }}
        el-button(
            v-if="missingGroups.length && form.prices[mainPriceIndex] && form.prices[mainPriceIndex].value"
            type="warning"
            @click="generateMissingGroupPrices"
        ) {{ $t('Generate missing customer group prices') }}
        el-button(
            type="primary"
            icon="el-icon-fa-plus fas"
            @click="addSalePrice"
        ) {{ $t('Add special price') }}
</template>

<i18n>
{
    "de": {
        "Consider generating the missing prices by clicking the button below.": "Die fehlenden Preise können per Klick auf die untere Schaltfläche generiert werden.",
        "Generate missing customer group prices": "Fehlende Kundengruppenpreise generieren",
        "Add special price": "Sonderpreis hinzufügen",
        "Add a different main price": "Abweichenden Standardpreis hinzufügen",
        "Define an individual article price": "Abweichenden Artikelpreis definieren"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';

import pinia from '@/pinia';
import { useSetupStore, useShopArticleStore, useShopProductStore } from '@/stores';

import PricesTab from '@/extensions/shop/views/Product/Form/Prices';
import Price from './Price';

export default {
    name: 'ArticlePriceTab',
    extends: PricesTab,
    components: {
        Price
    },
    computed: {
        setupStore() {
            return useSetupStore(pinia);
        },
        shopArticleStore() {
            return useShopArticleStore(pinia);
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        productMainPriceIndex() {
            return _.findIndex(this.product.form.prices, el => el.type === 'main');
        },
        form() {
            return this.shopArticleStore.form;
        },
        product() {
            return this.shopProductStore.$state;
        },
        rules() {
            return this.shopArticleStore.rules;
        },
        options() {
            return this.shopArticleStore.options;
        },
        activeCms() {
            return this.setupStore.activeCms;
        }
    },
    methods: {
        generateMissingGroupPrices() {
            if (this.missingGroups && this.missingGroups.length) {
                this.missingGroups.forEach(customerGroup => {
                    this.addPrice({
                        id: uniqid('new:'),
                        value: _.get(this.form.prices[this.mainPriceIndex], 'value'),
                        tax: _.get(this.form.prices[this.mainPriceIndex], 'tax'),
                        tax_rate: _.get(this.form.prices[this.mainPriceIndex], 'tax_rate'),
                        type: 'group',
                        customerGroup,
                        start_at: null,
                        end_at: null
                    });
                });
            }
        },
        addSalePrice() {
            const customerGroup = _.get(this.activeShop, 'defaultCustomerGroup');

            let value = _.get(this.form.prices[this.mainPriceIndex], 'value');
            if (!value) value = _.get(this.product.form.prices[this.productMainPriceIndex], 'value');

            let tax = _.get(this.form.prices[this.mainPriceIndex], 'tax');
            if (!tax) tax = _.get(this.product.form.prices[this.productMainPriceIndex], 'tax');

            let tax_rate = _.get(this.form.prices[this.mainPriceIndex], 'tax_rate');
            if (!tax_rate) tax_rate = _.get(this.product.form.prices[this.productMainPriceIndex], 'tax_rate');

            this.addPrice({
                id: uniqid('new:'),
                value,
                tax,
                tax_rate,
                type: 'sale',
                customerGroup,
                start_at: null,
                end_at: null
            });
        },
        addMainPrice() {
            const customerGroup = _.get(this.activeShop, 'defaultCustomerGroup');

            this.addPrice({
                id: uniqid('new:'),
                value: _.get(this.product.form.prices[this.productMainPriceIndex], 'value'),
                tax: _.get(this.product.form.prices[this.productMainPriceIndex], 'tax'),
                tax_rate: _.get(this.product.form.prices[this.productMainPriceIndex], 'tax_rate'),
                type: 'main',
                customerGroup,
                start_at: null,
                end_at: null
            });
        },
        addPrice(price) {
            this.shopArticleStore.addFormPrice(price);
        }
    }
};
</script>

<style lang="sass" scoped>

.main-price,
.price-placeholder
    margin-bottom: 25px
    border-bottom: 3px dotted $--shop-color-primary

.price-placeholder
    position: relative
    display: block
    text-decoration: none
    &:hover,
    &:focus,
        .overlay
            background-color: rgba(255, 255, 255, 0.9)
            // border-color: $--shop-color-primary
            .info
                opacity: 1
    .overlay
        display: flex
        justify-content: center
        align-items: center
        background-color: rgba(255, 255, 255, 0.4)
        border: 3px dashed rgba(255, 255, 255, 0)
        border-radius: 3px
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        z-index: 1
        transition: background-color .15s ease, border-color .15s ease
        .info
            transition: opacity .15s ease
            opacity: 0
            font-size: 1.2rem
            color: $--shop-color-primary
</style>
